import type { DeadlineRecurrenceChoice } from '../dto/deadline/deadline-management.constants';
import { isOtherDocumentType } from '../dto/document-type/document-type-catalog.constants';
import { isRecurringDeadline } from './deadline-dates';

/** Campi del tipo di catalogo che decidono la preselezione; `DocumentTypeItem` (frontend) li soddisfa. */
export interface RecurrencePreselectionSource {
  defaultValidityMonths: number | null;
  warningOnly: boolean;
  recurrenceAnchor: string | null;
  defaultWarningDays: readonly number[];
  catalogKey: string | null;
}

/**
 * Spec §11.1: validità di default o `warningOnly` → RECURRING; tipo senza data per natura (nessuna
 * ancora, nessun preavviso, non "Altro") → NONE; altrimenti `undefined` (scelta obbligatoria).
 */
export function resolveRecurrencePreselection(
  type: RecurrencePreselectionSource | null,
): DeadlineRecurrenceChoice | undefined {
  if (!type) {
    return undefined;
  }
  if (type.defaultValidityMonths !== null || type.warningOnly) {
    return 'RECURRING';
  }
  const isUndatedByNature =
    !isOtherDocumentType(type) &&
    type.recurrenceAnchor === null &&
    type.defaultWarningDays.length === 0;
  return isUndatedByNature ? 'NONE' : undefined;
}

/** Risposta di una riga esistente: RECURRING se `isRecurringDeadline`, NONE senza data, altrimenti ONE_OFF. */
export function recurrenceChoiceOf(row: {
  validityMonths: number | null;
  dueAt: string | null;
}): DeadlineRecurrenceChoice {
  if (isRecurringDeadline(row)) {
    return 'RECURRING';
  }
  return row.dueAt === null ? 'NONE' : 'ONE_OFF';
}
